<span
  [ngClass]="classes"
  [class.is-header]="isHeader"
  class="items-center text-tiny font-bold"
>
  {{ formattedNumber }}</span
>
